const RACE_TO_THE_RING_THRESHOLDS = Object.freeze({
  executive: 5_000_000,
  leader: 2_500_000,
  agent: 250_000,
})

const RACE_TYPE_PATTERNS = [
  { key: 'executive', tests: [/rick/i, /executive/i, /ceo/i] },
  { key: 'leader', tests: [/leader/i, /division/i] },
  { key: 'agent', tests: [/agent/i] },
]

const getRaceKeyFromType = (type = '') => {
  const normalized = `${type}`.toLowerCase()

  const match = RACE_TYPE_PATTERNS.find(({ tests }) => tests.some(pattern => pattern.test(normalized)))

  return match?.key || 'agent'
}

const getRaceKeyFromMilestone = milestone => {
  if (!milestone) return 'agent'

  const type = typeof milestone.get === 'function' ? milestone.get('mi_type') : milestone?.mi_type

  if (type) return getRaceKeyFromType(type)

  if (typeof milestone.raw === 'function') {
    const rawType = milestone.raw()?.mi_type
    if (rawType) return getRaceKeyFromType(rawType)
  }

  return 'agent'
}

const getRaceThresholdByKey = key => RACE_TO_THE_RING_THRESHOLDS[key] ?? RACE_TO_THE_RING_THRESHOLDS.agent

const getRaceThresholdForMilestone = milestone => getRaceThresholdByKey(getRaceKeyFromMilestone(milestone))

export {
  RACE_TO_THE_RING_THRESHOLDS,
  getRaceKeyFromType,
  getRaceKeyFromMilestone,
  getRaceThresholdByKey,
  getRaceThresholdForMilestone,
}
